import React from 'react';
import PropTypes from 'prop-types';
import * as utils from './../../utilities/calendarUtilities';
import { useLanguage } from '../../context/LanguageContext';

const Reserve = (props) => {
  const { labels } = useLanguage();
  const reserveStrings = labels.reserveStrings || {};
  const departure = utils.getUTC(props.startDate);
  const arrival = utils.getUTC(props.endDate);

  return (
    <div className="Pairing-Table">
      <div className="main-header">
        <div className="data-block">
          <div className="title">
            {reserveStrings.RESERVE}
          </div>
          <div className="details">
            {props.name}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {reserveStrings.DEPARTURE}
          </div>
          <div className="details">
            {utils.getFormattedDate(departure)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {reserveStrings.ARRIVAL}
          </div>
          <div className="details">
            {utils.getFormattedDate(arrival)}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {reserveStrings.AVAILABILITY}
          </div>
          <div className="details">
            {props.nbSeniorOutbids} {reserveStrings.AVAILABILITY_DETAIL}
          </div>
        </div>
        <div className="data-block">
          <div className="title">
            {reserveStrings.GROUP_ACTIVITIES_TYPE}
          </div>
          <div className="details">
            {props.groupActivitiesType}
          </div>
        </div>
      </div>
    </div>
  );
};

Reserve.defaultProps = {
  name: '',
  startDate: 0,
  endDate: 0,
  nbSeniorOutbids: 0
};

Reserve.propTypes = {
  name: PropTypes.string.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  groupActivitiesType: PropTypes.string.isRequired,
  nbSeniorOutbids: PropTypes.number
};

export default Reserve;
